import { createRouter, createWebHashHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import AppLayout from '@/components/appLayout.vue'; // 导入布局组件
import LoginView from '@/views/login/LoginView.vue';
import RegisterView from '@/views/login/RegisterView.vue';
import { trackPageView, getExcludedRoutes } from '@/utils/viewTracker'; // 导入访问记录工具
const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView // 登录页不需要布局
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView // 注册页不需要布局
  },
  {
    path: '/',
    redirect: '/login' // 默认重定向到登录页
  },
  {
    path: '/',
    component: AppLayout, // 应用布局组件
    children: [
      {
        path: '/home',
        name: 'home',
        component: HomePage,
        meta: { requiresAuth: true }
      },
      //公共部分
      {
        // 全局搜索
        path: '/common/global_search',
        name: 'globalSearch',
        component: () =>import('@/views/common/global_search.vue'),
        meta: { title: '搜索结果' }
      },
      {
        //行情统计
        path: '/common/market_performance/:comp_exch',
        name: 'marketPerformance',
        component: () =>import('@/views/common/market_performance.vue'),
        meta: { title: '行情统计' },
        props: true // 开启props传递，方便页面接收参数
      },

      //调研报告
      {
        path: '/common/investigation_report/:comp_exch',
        name: 'investigationReport',
        component: () =>import('@/views/common/investigation_report.vue'),
        meta: { title: '调研报告' },
        props: true // 开启props传递，方便页面接收参数
      },
      {
        //大宗交易
        path: '/common/block_trades/:comp_exch',
        name: 'blockTrades',
        component: () =>import('@/views/common/block_trades.vue'),
        meta: { title: '大宗交易' },
        props: true // 开启props传递，方便页面接收参数
      },

      //北交所核心池
      {
        path: '/beijing_exchange/core_pool/:comp_exch',
        name: 'corePool',
        component: () => import('@/views/beijing_exchange/core_pool.vue'),
        meta: { title: '核心池' } ,
        props: true // 开启props传递，方便页面接收参数
      },
      //北交所核心池投资组合
      {
        path: '/beijing_exchange/portfolio_detail/:id',
        name: 'portfolioDetail', 
        component: () => import('@/views/beijing_exchange/portfolio_detail.vue'),
        meta: { title: '投资组合详情' }
      },
     //北交所To50
      {
        path: '/beijing_exchange/portfolio_detail',
        name: 'top50PortfolioDetail', 
        component: () => import('@/views/beijing_exchange/portfolio_detail.vue'),
        meta: { title: 'Top50' }
      },
      // 公司详情
      {
        path: '/new_third_board/company_detail/:code',
        name: 'companyDetail',
        component: () =>import('@/views/common/company_detail.vue'),
        meta: { title: '公司详情' }
      },
      // 北交所并购重组
      {
        path: '/beijing_exchange/mergers_and_acquisitions',
        name: 'mergersAndAcquisitions',
        component: () =>import('@/views/beijing_exchange/mergers_and_acquisitions.vue'),
        meta: { title: '并购重组' }
      },
      {
        // 北交所龙虎榜
        path: '/beijing_exchange/dragon_and_tiger_list',
        name: 'dragonAndTigerList',
        component: () =>import('@/views/beijing_exchange/dragon_and_tiger_list.vue'),
        meta: { title: '龙虎榜' }
      },
      {
        // 北交所标签管理
        path: '/beijing_exchange/sector_data_table',
        name: 'sectorDataTable',
        component: () =>import('@/views/beijing_exchange/sector_data_table.vue'),
        meta: { title: '标签管理' }
      },
      {
        // 北交所标签管理
        path: '/beijing_exchange/financing',
        name: 'financing',
        component: () =>import('@/views/beijing_exchange/financing.vue'),
        meta: { title: '融资' }
      },
      
      //上传组合
      {
        path: "/beijing_exchange/create_portfolio",
        name: "createPortfolio",
        component: () =>import('@/views/beijing_exchange/createPortfolio.vue'),
        meta: { title: '上传组合' }
      },
      //新三板机构名录
      {
        path: '/new_third_board/institution_directory',
        name: 'institutionDirectory', // 注意命名规范
        component: () => import('@/views/new_third_board/institution_directory.vue'),
        meta: {title: '机构名录'}
      },
      // 新三板机构详情
      {
        path: '/new_third_board/institution_detail/:id',  // 动态路由（接收id参数）
        name: 'institutionDetail',
        component: () => import('@/views/new_third_board/institution_detail.vue'),
        meta: { title: '机构详情' }
      },
      // 新三板新挂牌
      {
        path: '/new_third_board/newly_listed',
        name: 'newlyListed',
        component: ()=>import('@/views/new_third_board/newly_listed.vue'),
        meta: { title: '新挂牌' }
      },

      //新三板_做市商变动汇总页
      {
        path: '/new_third_board/market_maker_change',
        name: 'marketMakerChange',
        component: () =>import('@/views/new_third_board/marketmaker_change.vue'),
        meta: { title: '做市商变动' }
      },
      //新三板_做市商变动推荐页
      {
        path: '/new_third_board/market_maker_recom/:broker_id/:broker_name/:recom',
        name: 'marketMakerRecom',
        component: () =>import('@/views/new_third_board/marketmaker_recom.vue'),
        meta: { title: '做市商推荐公司' }
      },
      //新三板_做市商变动做市页
      {
        path: '/new_third_board/market_maker_maker/:broker_id/:broker_name/:maker_market',
        name: 'marketMakerMaker',
        component: () =>import('@/views/new_third_board/marketmaker_maker.vue'),
        meta: { title: '做市商公司' }
      },
      //新三板_做市商变动日历页
      {
        path: '/new_third_board/market_maker_calendar/:broker_id/:broker_name',
        name: 'marketMakerCalendar',
        component: () =>import('@/views/new_third_board/marketmaker_calendar.vue'),
        meta: { title: '做市变动日历' }
      },
      //新三板_做市商列表页（按公司查看）
      {
        path: '/new_third_board/broker_list/:comp_code/:create_date/:data_type/:comp_name',
        name: 'brokerList',
        component: () =>import('@/views/new_third_board/broker_list.vue'),
        meta: { title: '做市商列表' }
      },
      //新三板_企业行情页（从日历跳转）
      {
        path: '/new_third_board/company_quotes/:broker_id/:broker_name/:create_date/:data_type',
        name: 'companyQuotes',
        component: () =>import('@/views/new_third_board/company_quotes.vue'),
        meta: { title: '企业行情' }
      },
      //新三板_公司做市日历页
      {
        path: '/new_third_board/company_calendar/:comp_code/:comp_name',
        name: 'companyCalendar',
        component: () =>import('@/views/new_third_board/company_calendar.vue'),
        meta: { title: '公司做市日历' }
      },
      
      //新三板_定向增发列表页
      {
        path: '/new_third_board/private_placement',
        name: 'privatePlacement',
        component: () =>import('@/views/new_third_board/private_placement.vue'),
        meta: { title: '定向增发' }
      },
      {
        // 新三板定向增发详情
        path: '/new_third_board/private_placement_detail/:code',
        name: 'privatePlacementDetail',
        component: () =>import('@/views/new_third_board/private_placement_detail.vue'),
        meta: { title: '定向增发详情' }
      },
      {
        // 新三板壳交易
        path: '/new_third_board/shell_transactions',
        name: 'shellTransactions',
        component: () =>import('@/views/new_third_board/shell_transactions.vue'),
        meta: { title: '壳交易' }
      },
      {
        // 新三板壳交易详情
        path: '/new_third_board/shell_transactions_detail/:code',
        name: 'shellTransactionsDetail',
        component: () =>import('@/views/new_third_board/shell_transactions_detail.vue'),
        meta: { title: '壳交易详情' }
      },
      {
        // 新三板股票池
        path: '/new_third_board/stocks_group/:comp_exch',
        name: 'stocksGroup',
        component: () =>import('@/views/new_third_board/stocks_group.vue'),
        meta: { title: '股票池' },
        props: true // 开启props传递，方便页面接收参数
      },
      {
        // 新三板股票池内
        path: '/new_third_board/stocks_group_list/:id',
        name: 'stocksGroupList',
        component: () =>import('@/views/new_third_board/stocks_group_list.vue'),
        meta: { title: '股票池内' }
      },
      {
        // IPO有潜力公司
        path: '/ipo/high_potential_company',
        name: 'highPotentialCompany',
        component: () =>import('@/views/ipo/high_potential_company.vue'),
        meta: { title: '高潜公司' }
      },
      {
        // IPO上会过会
        path: '/ipo/ipo_review_meeting',
        name: 'ipoReviewMeeting',
        component: () =>import('@/views/ipo/ipo_review_meeting.vue'),
        meta: { title: '上会过会' }
      },
      {
        // IPO审议委员
        path: '/ipo/committeeMembers',
        name: 'committeeMembers',
        component: () =>import('@/views/ipo/committeeMembers.vue'),
        meta: { title: '参会委员' }
      },
      {
        // IPO委员审核企业列表
        path: '/ipo/committer_companies/:committer_id/:committer_name',
        name: 'committerCompanies',
        component: () =>import('@/views/ipo/committer_companies.vue'),
        meta: { title: '委员审核企业' }
      },
      //IPO状态
      {
        path: '/ipo/state/:state_stage',
        name: 'ipoStateList',
        component: () => import('@/views/ipo/ipo_state_list.vue'),
        meta: { title: 'IPO状态' },
        props: true // 开启props传递，方便页面接收参数
      },
      {
        // IPO发行方案汇总
        path: '/ipo/ipo_issue_plan',
        name: 'ipoIssuePlan',
        component: () =>import('@/views/ipo/ipo_issue_plan.vue'),
        meta: { title: '发行方案' }
      },
      {
        // IPO发行方案汇总
        path: '/ipo/ipo_termination',
        name: 'ipoTermination',
        component: () =>import('@/views/ipo/ipo_termination.vue'),
        meta: { title: '终止原因' }
      },
      {
        // IPO发行方案汇总
        path: '/ipo/ipo_inquiry',
        name: 'ipoInquiry',
        component: () =>import('@/views/ipo/ipo_inquiry.vue'),
        meta: { title: '问询问题' }
      },
      {
        // IPO问询公司列表
        path: '/ipo/inquiry_comp_list',
        name: 'inquiryCompList',
        component: () =>import('@/views/ipo/inquiry_comp_list.vue'),
        meta: { title: '问询公司列表' }
      },
      //IPO全流程
      {
          path: '/ipo/ipo_process/:code',
          name: 'ipoProcess',
          component: () =>import('@/views/ipo/ipo_process.vue'),
          meta: { title: 'IPO流程' }

      },
      //一级市场项目库
      {
          path: '/primary_market/project_directory',
          name: 'projectDirectory',
          component: () =>import('@/views/primary_market/project_directory.vue'),
          meta: { title: '项目库' }
      },
      //一级市场项目详情
      {
          path: '/primary_market/project_detail/:id',
          name: 'projectDetail',
          component: () =>import('@/views/primary_market/project_detail.vue'),
          meta: { title: '项目详情' }
      },
      //一级市场立项库
      {
          path: '/primary_market/project_found_list',
          name: 'projectFoundList',
          component: () =>import('@/views/primary_market/project_found_list.vue'),
          meta: { title: '项目库' }
      },
      //一级市场投前详情
      {
          path: '/primary_market/preFound_detail/:id',
          name: 'preFoundDetail',
          component: () =>import('@/views/primary_market/preFound_detail.vue'),
          meta: { title: '项目详情' }
      },
      //一级市场投前
      {
          path: '/primary_market/pre_investment',
          name: 'preInvestment',
          component: () =>import('@/views/primary_market/pre_investment.vue'),
          meta: { title: '投前' }
      },
      //一级市场投中
      {
          path: '/primary_market/during_investment',
          name: 'duringInvestment',
          component: () =>import('@/views/primary_market/during_investment.vue'),
          meta: { title: '投中' }
      },
      //一级市场投后
      {
          path: '/primary_market/post_investment',
          name: 'postInvestment',
          component: () =>import('@/views/primary_market/post_investment.vue'),
          meta: { title: '投后' }
      },
      //一级市场项目上传
      {
          path: '/primary_market/found_project',
          name: 'foundProject',
          component: () =>import('@/views/primary_market/found_project.vue'),
          meta: { title: '项目上传' }
      },
      // 我的账户
      {
          path: '/user/my_account',
          name: 'myAccount',
          component: () =>import('@/views/user/MyAccount.vue'),
          meta: { title: '我的账户' }
      },
    ]
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 修复导航守卫逻辑
router.beforeEach((to, from, next) => {
  //处理IPO状态页标题
  if (to.name === 'ipoStateList') {
    const stateMap = {
      'preparation': '筹备期',
      'counseling': '辅导期',
      'examination ': '审核期',
      'review':'审议期',
      'registration': '注册期',
    };
    to.meta.title = stateMap[to.params.state] || 'IPO状态';
  }

  // 登录验证逻辑
  // 登录页直接放行
  if (to.path === '/login') {
    next();
    return;
  }

  // 检查是否需要登录（默认所有页面都需要登录）
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth) || true;
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  if (requiresAuth && !isLoggedIn) {
    // 未登录且需要权限，重定向到登录页
    localStorage.setItem('redirectPath', to.fullPath);
    next('/login');
  } else {
    // 已登录或不需要权限，正常访问
    next();
  }
});

// 全局后置守卫：记录用户访问
router.afterEach((to, from) => {
  
  // 排除不需要记录的路由
  const excludedRoutes = getExcludedRoutes();
  
  if (excludedRoutes.includes(to.name)) {
    return;
  }

  // 延迟记录，确保页面渲染完成
  setTimeout(() => {
    trackPageView(to, from);  // 传递 from 参数
  }, 300);
});

export default router;